export const UNAVAILABLE_BAY_ID = 'unavailable'
